import { createFileRoute } from '@tanstack/react-router'

import { SingleProfile } from '@/widgets/case-management/single-profile'

export const Route = createFileRoute('/_app/case-management/profiles/$id')({
  component: RouteComponent,
})

export const SingleCaseManagementProfileRoute = Route

function RouteComponent() {
  const { id } = SingleCaseManagementProfileRoute.useParams()

  return <SingleProfile id={id} />
}
